import axios from 'axios';
import { DEFAULT_CONFIG, ENG_CONFIG } from '../constants/routes';

const artifactoryOrigin = () =>
  (window._env_?.ARTIFACTORY_ORIGIN || '').replace(/\/$/, '');

const withArtifactory = (path) => {
  const origin = artifactoryOrigin();
  return origin ? origin + path : path;
};

/**
 * fetchs and return the locale configuration stored in public folder
 * (or artifactory when ARTIFACTORY_ORIGIN is set)
 * @returns json object
 */
const getLocaleConfiguration = async () => {
  const response = await axios.get(withArtifactory(DEFAULT_CONFIG));
  return response.data;
};

const getEnLocaleConfiguration = async () => {
  const response = await axios.get(withArtifactory(ENG_CONFIG));
  return response.data;
};

const getLangCodeMapping = async () => {
  let localConfig = await getLocaleConfiguration();
  let reverseMap = Object.entries(localConfig.langCodeMapping).reduce(
    (pv, [key, value]) => ((pv[value] = key), pv),
    {}
  );
  return reverseMap;
};

const langConfigService = {
  getLocaleConfiguration,
  getLangCodeMapping,
  getEnLocaleConfiguration,
};

export default langConfigService;
